import { isEmpty } from 'lodash-es';
import {
  NAV_SET_MAIN_VIEW,
  NAV_SET_SUB_VIEW,
  NAV_SET_IS_AUTH,
} from '@/store/action_types/nav';
import router from '@/router';
// import store from '@/store';

import eventBus from '@/setup/eventBus';
import { useApi } from '@/api';
import { useTypedStore } from '@/store';
import { bootstrapApp } from '@/setup/bootstrap';
import type { GetAclResponse } from '@/types/openapi-ts';

const store = useTypedStore();

const DEFAULT_ROUTE = '/affiliates/list';

const hasPermissions = (
  permissions: (keyof NonNullable<GetAclResponse['payload']['permissions']['someStringKey']>)[],
  mode: string
) => {
  // Allow all for super user
  if (store.getters['auth/adminAcl'].is_superuser) return true;

  const callback = (
    permission: keyof NonNullable<GetAclResponse['payload']['permissions']['someStringKey']>
  ) => store.getters['auth/currentAcl']?.[permission] !== 'deny';

  return (mode === 'and') ? permissions.every(callback) : permissions.some(callback);
};

const logEnabled = false;
const nglog = (...params: string[]) => {
  if(logEnabled) {
    console.log(...params);
  }
};

const hasViewAffiliatePermissions = () => {
  const isSuper = store.getters['auth/adminAcl'].is_superuser;
  const currentAcl = store.getters['auth/currentAcl'];
  return (isSuper || (currentAcl && currentAcl.affiliates_view === 'allow'));
};

export default () => {
  // eslint-disable-next-line consistent-return
  router.beforeEach(async (to, from, _next) => {
    const api = useApi();
    let nextCalled = false;
    let next = (...route: any[]) => {
      if(!nextCalled) {
        nextCalled = true;
        if(logEnabled) {
          console.log({to, from, route});
        }
        _next(...route as []);
      }
    };

    let hasRedirect = false;
    /**
     * Запрет перехода в Teams если статус lock
     */
    if (from.matched[0] !== undefined && to.matched?.[0]?.path === '/teams' && store.getters['session/significantActionsSeconds'] === 0) {
      eventBus.$emit('checkSensitiveAction', 'teamsRoute');
      return;
    }

    if (from.matched[0] !== undefined && to.path === '/settings/token-management' && store.getters['session/significantActionsSeconds'] === 0) {
      eventBus.$emit('checkSensitiveAction', 'tokenManagementRoute');
      return;
    }

    if (from.matched[0] !== undefined && to.path === '/settings/fees' && store.getters['session/significantActionsSeconds'] === 0) {
      eventBus.$emit('checkSensitiveAction', 'feesRoute');
      return;
    }

    if (from.matched[0] !== undefined && to.path === '/settings/payment-methods' && store.getters['session/significantActionsSeconds'] === 0) {
      eventBus.$emit('checkSensitiveAction', 'paymentMethodsRoute');
      return;
    }

    if (from.matched[0] !== undefined && to.path === '/settings/system-settings' && store.getters['session/significantActionsSeconds'] === 0) {
      eventBus.$emit('checkSensitiveAction', 'systemSettings');
      return;
    }

    if (from.matched[0] !== undefined && to.path === '/settings/system-domains' && store.getters['session/significantActionsSeconds'] === 0) {
      eventBus.$emit('checkSensitiveAction', 'systemDomains');
      return;
    }

    if (from.matched[0] !== undefined && to.path === '/settings/predefined-page' && store.getters['session/significantActionsSeconds'] === 0) {
      eventBus.$emit('checkSensitiveAction', 'predefinedPage');
      return;
    }

    if (from.matched[0] !== undefined && to.path === '/settings/offers-country-groups' && store.getters['session/significantActionsSeconds'] === 0) {
      eventBus.$emit('checkSensitiveAction', 'offersCountryGroups');
      return;
    }

    if (from.matched[0] !== undefined && to.path === '/settings/currencies' && store.getters['session/significantActionsSeconds'] === 0) {
      eventBus.$emit('checkSensitiveAction', 'currenciesRoute');
      return;
    }

    if (from.matched[0] !== undefined && to.path === '/settings/media-buying' && store.getters['session/significantActionsSeconds'] === 0) {
      eventBus.$emit('checkSensitiveAction', 'mediaBuyingRoute');
      return;
    }


    /**
     * Запрет перехода со страницы редактирования дашборда
     */
    if (from.matched[0]?.path === '/dashboards' && store.state.dashboards.editMode) {
      eventBus.$emit('confirmEditDashboards', to);
      return;
    }

    //@ts-expect-error matched typings
    store.commit(`nav/${NAV_SET_MAIN_VIEW}`, to.matched[0]?.meta.view);
    if (to.matched[1] && to.matched[1].meta.view) {
      //@ts-expect-error matched typings
      store.commit(`nav/${NAV_SET_SUB_VIEW}`, to.matched[1]?.meta.view);
    }
    store.commit(`nav/${NAV_SET_IS_AUTH}`, to.matched.some((record) => record.meta.type === 'auth'));

    // if (history.state?.ignoreNavGuard === true) {
    //   nglog('17');
    //   next();
    //   return;
    // }

    if (to.matched.some((record) => record.meta.type === 'token-auth')) {
      //@ts-expect-error matched typings
      store.commit('auth/AUTH_BY_TOKEN', to.params.token);
      api.affiliatesApi.defaults.headers.common.Authorization = to.params.token;

      try {
        await bootstrapApp({ force: true });
      } catch {
        next(false);
        return;
      }
      nglog('01');
      next(DEFAULT_ROUTE);
    }
    if (to.matched.some((record) => record.meta.type === 'auth')) {
      if (store.getters['auth/isAuthenticated']) {
        // hasRedirect = true;
        nglog('02');
        next(DEFAULT_ROUTE);
      } else {
        switch (to.params.action) {
        case 'auth':
          if (store.getters['auth/authStatus'] === 'success') {
            nglog('03');
            next('/login/2fa');
          }
          nglog('04');
          next();
          break;
        case '2fa':
          if (store.getters['auth/authStatus'] !== 'success') {
            nglog('05');
            next('/login/auth');
          } else if (store.getters['auth/tfaStatus'] !== 'success') {
            nglog('06');
            next();
          } else {
            nglog('07');
            next(DEFAULT_ROUTE);
          }
          break;
        default:
          break;
        }
        nglog('08');
        next();
      }
    }

    if (to.matched.some((record) => record.meta.requiresAuth)) {
      if (!store.getters['auth/isAuthenticated']) {
        nglog('12');
        next('/login');
        return;
      }

      try {
        await bootstrapApp();
      } catch {
        nglog('16');
        next(false);
        return;
      }

      const isReportsRoute = ['/reports', '/dashboards'].includes(to.matched[0]?.path as string);

      if (isReportsRoute && isEmpty(store.getters['reports/reportsSettings'])) {
        await store.dispatch('reports/getSettings');
      }

      if (!store.getters['auth/adminAcl'].is_superuser) {
        if (to.path === '/crm/activities/list' && store.getters['auth/currentAcl']!.crm_activities_view === 'deny') {
          hasRedirect = true;
          nglog('09');
          next('/crm/segments');
        }
        if (to.path === '/crm/segments' && store.getters['auth/currentAcl']!.crm_segments_view === 'deny') {
          nglog('10');
          next(DEFAULT_ROUTE);
        }
        if (to.path === DEFAULT_ROUTE && !hasViewAffiliatePermissions())  {
          nglog('15');
          next('/profile');
        }
      }
      if (to.meta.permission) {
        const { mode = 'and', list = [] } = to.meta.permission as { mode: string, list: any[] };

        if (!hasPermissions(list, mode)) {
          nglog('11');
          next(DEFAULT_ROUTE);
        }
      }

      if (!hasRedirect) {
        nglog('13');
        next();
      }
    } else if (!hasRedirect) {
      nglog('14');
      next();
    }

    // console.log('nextRoute', nextRoute);
    // _next(...nextRoute);
  });
};
